import { css, etiColors, mediaQueries, keyframes } from '@eti/styles';
import Media from 'react-media';
import {
  Segment,
  FullWidthColumn,
  CarrierColumn,
  TripDetailsSegmentInfoWrapper,
  LocationAndTimeWrapper,
  DurationWrapper,
  baggageColumnWrapperClass,
  PlaceholderColumn,
} from '../../../../../widgets/trip-details/components/styles/tripDetailsSegment';

const pulseLoadingAnimation = keyframes`
  0% {opacity: 0.5;}
  50% {opacity: 0.8;}
  80% {opacity: 1;}
  100% {opacity: 0.5;}
`;

export const skeletonClassStyle = css`
  animation: ${pulseLoadingAnimation} 2s ease-in-out infinite;
  background-color: #ddd;
  background-size: 200px 100%;
  line-height: 1;
`;

export const smallSkeleton = css`
  height: 8px;
  ${skeletonClassStyle};

  @media ${mediaQueries.medium.up} {
    height: 10px;
  }
`;

export const mediumSkeleton = css`
  height: 16px;
  ${skeletonClassStyle};

  @media ${mediaQueries.medium.up} {
    height: 22px;
  }
`;

const carrierInfoSkeletonStyles = css`
  ${skeletonClassStyle};
  ${smallSkeleton};
  width: 56px;

  @media ${mediaQueries.large.up} {
    width: 80px;
  }
`;

const carrierLogoSkeletonStyles = css`
  border-radius: 50%;
  height: 20px;
  ${skeletonClassStyle};
  width: 20px;

  @media ${mediaQueries.medium.up} {
    height: 32px;
    width: 32px;
  }

  @media ${mediaQueries.large.up} {
    height: 40px;
    width: 40px;
  }
`;

const timeSkeletonStyles = css`
  margin: 0 auto 4px;
  ${skeletonClassStyle};
  ${mediumSkeleton};
  width: 60px;

  @media ${mediaQueries.medium.up} {
    margin-bottom: 6px;
    width: 80px;
  }
`;

const baggageSkeletonStyles = css`
  ${skeletonClassStyle};
  ${smallSkeleton};
  padding-right: 10px;
  width: 56px;

  @media ${mediaQueries.medium.up} {
    width: 80px;
  }
`;

const locationSkeletonStyles = css`
  margin: 3px auto 0;
  ${skeletonClassStyle};
  ${smallSkeleton};
  width: 80px;

  @media ${mediaQueries.medium.up} {
    margin-top: 6px;
    width: 130px;
  }
`;

const durationSkeletonStyles = css`
  margin: 0 auto 6px;
  ${skeletonClassStyle};
  ${smallSkeleton};
  width: 60px;

  &:last-child {
    margin-bottom: 0;
  }

  @media ${mediaQueries.medium.up} {
    width: 76px;
  }

  @media ${mediaQueries.large.up} {
    width: 100px;
  }
`;

const segmentStyles = css`
  background-color: ${etiColors.white};
  border-bottom: 1px dotted ${etiColors.grayScale[7]};
  padding-bottom: 8px;

  @media ${mediaQueries.medium.up} {
    padding-bottom: 0;
  }
`;

const TripDetailsBoundSkeleton = () => (
  <section className={segmentStyles} data-testid="skeleton-bound">
    <Segment>
      <div className={FullWidthColumn}>
        <CarrierColumn>
          <Media query={mediaQueries.medium.up}>
            {(matches) => (
              <>
                <div className={carrierLogoSkeletonStyles} />
                {matches ? (
                  <TripDetailsSegmentInfoWrapper>
                    <div className={carrierInfoSkeletonStyles} />
                  </TripDetailsSegmentInfoWrapper>
                ) : (
                  ''
                )}
              </>
            )}
          </Media>
        </CarrierColumn>
        <LocationAndTimeWrapper>
          <p className={timeSkeletonStyles} />
          <p className={locationSkeletonStyles} />
          <p className={locationSkeletonStyles} />
        </LocationAndTimeWrapper>
        <DurationWrapper>
          <p className={durationSkeletonStyles} />
          <p className={durationSkeletonStyles} />
          <p className={durationSkeletonStyles} />
        </DurationWrapper>
        <LocationAndTimeWrapper>
          <p className={timeSkeletonStyles} />
          <p className={locationSkeletonStyles} />
          <p className={locationSkeletonStyles} />
        </LocationAndTimeWrapper>
        <Media query={mediaQueries.small.only}>
          {(matches) => (matches ? <PlaceholderColumn /> : '')}
        </Media>
      </div>
      <div className={baggageColumnWrapperClass}>
        <div className={baggageSkeletonStyles} />
      </div>
    </Segment>
  </section>
);
export default TripDetailsBoundSkeleton;
